module.exports = "/_next/static/resources/photo-2-2939632f2acc7108c3e9d97c692b9185.webp";